import React from 'react'
import AddEmployee from "../component/AddEmployee"
import AddBranch from "../component/AddBranch"
import AddDepartment from "../component/AddDepartment"
import AddDispute from "../component/AddDispute"
import AddDocument from "../component/AddDocument"
import { useParams } from 'react-router-dom'


const UpdateForm = () => {
  const update= true
  const {type} = useParams()
  return (
     <div className="page-content">
     
         {type==="emp"?( <AddEmployee update={update}/>):type === "branch"?<AddBranch update={update}/>:type === "department" ? <AddDepartment update={update}/>: type === "dispute"? <AddDispute update={update}/>: type === "document"? <AddDocument update={update}/>: null}
    
        </div>
  )
}

export default UpdateForm
